import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDesignSystem24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDesignSystem24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m19.826 5.816-1.633-1.632a.5.5 0 0 0-.707 0L16.06 5.611l2.34 2.34 1.427-1.428a.5.5 0 0 0 0-.707M5.973 15.698l9.025-9.026 2.34 2.34-9.026 9.025-3 .66zm10.742-3.943 4.171-4.171a2 2 0 0 0 0-2.828l-1.632-1.633a2 2 0 0 0-2.828 0l-4.172 4.172-4.168-4.168a2 2 0 0 0-2.828 0L3.137 5.248a2 2 0 0 0 0 2.828l4.168 4.169-2.703 2.702-.923 4.192a1 1 0 0 0 1.192 1.191l4.192-.922 2.702-2.703 4.171 4.171a2 2 0 0 0 2.829 0l2.121-2.121a2 2 0 0 0 0-2.828zm-1.06 1.06-2.83 2.83 4.172 4.17a.5.5 0 0 0 .707 0l2.121-2.12a.5.5 0 0 0 0-.708l-.37-.37-.913.913a.75.75 0 0 1-1.061-1.06l.913-.914-.94-.94-.913.914a.75.75 0 0 1-1.06-1.06l.913-.914zm-7.29-1.631L4.197 7.016a.5.5 0 0 1 0-.707L6.32 4.187a.5.5 0 0 1 .707 0l.365.366-.917.916a.75.75 0 0 0 1.06 1.061l.917-.917.942.942-.914.914a.75.75 0 0 0 1.06 1.06l.915-.913.74.74z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDesignSystem24);
